import React, { useState } from 'react'

import { useAjaxContext } from '../../../../core/ajax'
import { ThemeButton } from '../../../../ui'

export const UserStateButtonComponent = ({ data, setData }) => {
  const { putById } = useAjaxContext()

  const [isLoading, setIsLoading] = useState(false)

  const handleToggleUserState = () => {
    setIsLoading(true)
    const { gremio_id, gremio, ...userData } = data
    putById('instalador', data['id'], { ...userData, activo: !data['activo'] })
      .then(({ data }) => {
        setData(data)
        setIsLoading(false)
      })
      .catch(() => {
        console.debug('Error fetching instalador data')
        setIsLoading(false)
      })
  }

  return (
    <ThemeButton variant="outlined" fullWidth loading={isLoading} onClick={handleToggleUserState}>
      {data['activo'] ? 'Deshabilitar' : 'Habilitar'}
    </ThemeButton>
  )
}
